import { X } from "lucide-react";
import React, { useState } from "react";
import CountryCodeDropDownAndPhoneField from "./countrycodedropdownandphonefield.tsx";
import VippsAuthenticate from "./vippsauthenticate.tsx";
import StripeAuthenticate from "./stripeauthenticate.tsx";
import useEscapeKey from "../../hooks/useEscapeKey.tsx";

export default function PaymentModal({
  isOpen,
  onClose,
  eventName,
  startDateTime,
  broadcastPrice,
  onSubmit,
  showCountryInputs = false,
  phoneNumber,
  setPhoneNumber,
  countryCode,
  setCountryCode,
  paymentMethod,
  setPaymentMethod,
  vippsAuthenticate,
  stripeAuthenticate,
}) {

  useEscapeKey(isOpen, onClose);
  const handleNoStripe = () => {
    setPaymentMethod("vipps");
  }
  const handleNoVipps = () => {
    setPaymentMethod("stripe");
  }

  if (!isOpen) return null;

  // If Vipps authenticate is active → return only this
  if (vippsAuthenticate && paymentMethod === "vipps") {
    return (
      <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
        <div className="bg-white rounded-3xl w-full max-w-lg shadow-xl animate-fadeIn">
          {/* Header */}
          <div className="flex items-center justify-between px-6 py-4 border-b">
            <h2 className="text-xl font-semibold">
              Payment Mode <span className="text-purple-600">{eventName}</span>
            </h2>

            <button onClick={onClose} className="p-1 hover:opacity-70">
              <X />
            </button>
          </div>

          {/* Body */}
          <div className="px-6 py-6">
            <VippsAuthenticate vippsAuthenticate={vippsAuthenticate} />
          </div>
        </div>
      </div>
    );
  }

  // If Stripe authenticate is active → return only this
  if (stripeAuthenticate && paymentMethod === "stripe") {
    return (
      <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
        <div className="bg-white rounded-3xl w-full max-w-lg shadow-xl animate-fadeIn">

          {/* Header */}
          <div className="flex items-center justify-between px-6 py-4 border-b">
            <h2 className="text-xl font-semibold">
              Payment Mode <span className="text-purple-600">{eventName}</span>
            </h2>

            <button onClick={onClose} className="p-1 hover:opacity-70">
              <X />
            </button>
          </div>

          {/* Body */}
          <div className="px-6 py-6">
            <StripeAuthenticate stripeAuthenticate={stripeAuthenticate} />
          </div>

        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white rounded-3xl w-full max-w-lg shadow-xl animate-fadeIn">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b">
          <h2 className="text-xl font-semibold">
            Payment Mode <span className="text-purple-600">{eventName}</span>
          </h2>

          <button onClick={onClose} className="p-1 hover:opacity-70">
            <X />
          </button>
        </div>

        {/* Body */}
        <div className="px-6 py-6">
          <form onSubmit={onSubmit} id="broadcastcuspayment" className="space-y-4">
            {/* Start Date Time */}
            <div>
              <label className="block mb-1 font-medium">Start Date Time</label>
              <input
                type="text"
                disabled
                id="start_date_time"
                name="start_date_time"
                value={startDateTime}
                className="w-full border rounded-lg px-3 py-2 bg-gray-100"
              />
            </div>

            <input type="hidden" id="payment_method" name="payment_method" value="vipps" />

            {/* Broadcast Price */}
            <div>
              <label className="block mb-1 font-medium">Broadcast Price</label>

              <input type="hidden" id="broadcast_sechdule" name="broadcast_sechdule" />

              <input
                type="text"
                disabled
                id="broadcast_price"
                name="broadcast_price"
                value={broadcastPrice}
                className="w-full border rounded-lg px-3 py-2 bg-gray-100"
              />

              <input type="hidden" id="broadcast_price_hidden" name="broadcast_price_hidden" />

              <div className="text-red-500 text-sm" id="enter_minute_error_message"></div>
            </div>

            {/* Country + Phone Inputs */}
            {showCountryInputs && (
              <CountryCodeDropDownAndPhoneField phoneNumber={phoneNumber} setPhoneNumber={setPhoneNumber} countryCode={countryCode} setCountryCode={setCountryCode} />
            )}

            {/* Vipps Button */}
            {paymentMethod === "vipps" ? (
              <div className="pt-4">
                <button
                  type="submit"
                  className="w-full flex items-center justify-center gap-2 bg-orange-500 hover:bg-orange-600 text-white py-3 rounded-xl font-semibold transition"
                >
                  Continue with Vipps

                </button>

                <div className="text-center mt-3">
                  <button
                    type="button"
                    className="text-sm text-blue-600 hover:underline btnDontHaveVipps"
                    onClick={handleNoVipps}
                  >
                    Don’t have Vipps?
                  </button>
                </div>
              </div>
            ) : (
              <div className="pt-4">
                <button
                  type="submit"
                  className="w-full flex items-center justify-center gap-2 bg-purple-500 hover:bg-purple-600 text-white py-3 rounded-xl font-semibold transition"
                >
                  Continue with Stripe

                </button>

                <div className="text-center mt-3">
                  <button
                    type="button"
                    className="text-sm text-blue-600 hover:underline btnDontHaveStripe"
                    onClick={handleNoStripe}
                  >
                    Don’t have Stripe?
                  </button>
                </div>
              </div>
            )}

          </form>
        </div>
      </div>
    </div>
  );
}